import React from 'react';
import { UseFormMethods } from 'react-hook-form';

interface IRHFToggleProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label: string;
    name: string;
    rules?: unknown;
    onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    bodyStyle?: React.CSSProperties;
    disabled?: boolean;
}

const RHFToggle = (props: IRHFToggleProps) => {
    return (
        <div className="form-field" style={props.bodyStyle}>
            <label htmlFor={props.name}>{props.label}</label>
            <br />
            <select name={props.name} ref={props.register ? props.register(props.rules) : undefined} className="field" onChange={props.onChange} disabled={props.disabled}>
                <option value={undefined} />
                <option value="true">Yes</option>
                <option value="false">No</option>
            </select>
            <br />
            {props.errors?.[props.name] && <p className="error-message">{props.errors?.[props.name]?.message}</p>}
        </div>
    );
};

export default RHFToggle;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFToggle.tsx